<template>
  <div>
    <editor-stepper
    />
    <loader v-if="loading"
      :label="$t('conflict.searchingTodos')"
    />
    <div v-else>
      <!-- f400 -->
      <choose-resolution-mode
        v-if="stepIsChooseResolutionMode" 
        :conflict="conflict"
        @answered="answered"
        @conflictResolutionCleared="selectConflict($event)"
        @nextTodo="nextTodo($event)"
        v-on="$listeners"
      />
      <choose-exclusive-and-unique-wigo-view
        v-else-if="stepIsChooseExclusiveAndUniqueWigo"
        :conflict="conflict"
        @nextTodo="nextTodo($event)"
        v-on="$listeners"
      />
      <challenge-preference
        v-else-if="stepIsChallengePreference"
        :todo="todo"
        @nextTodo="nextTodo($event)"
        v-on="$listeners"
      />
      <no-i-can-choose-by-adding-information
        v-else-if="stepIsChooseByAddingInformation"
        :conflict="conflict"
        :todo="todo"
        @nextTodo="nextTodo($event)"
        v-on="$listeners"
      />
      <no-i-can-choose-by-adding-information
        v-else-if="stepIsChooseByAddingInformationWithGroups"
        :conflict="conflict"
        :todo="todo"
        @nextTodo="nextTodo($event)"
        v-on="$listeners"
      />
      <suggest-possible-scenarios-union
        v-else-if="stepIsConfirmPossibleScenariosUnion"
        :todo="todo"
        @nextTodo="nextTodo($event)"
        v-on="$listeners"
      />
      <no-i-prefer-making-groups
        v-else-if="stepIsMakeGroups"
        :conflict="conflict"
        :todo="todo"
        @nextTodo="nextTodo($event)"
        v-on="$listeners"
      />
    </div>
  </div>
</template>
<script>
import ChooseResolutionMode from '@/components/conflictResolution/ChooseResolutionMode'
import ChooseExclusiveAndUniqueWigoView from '@/components/conflictResolution/ChooseExclusiveAndUniqueWigoView'
import ChallengePreference from '@/components/conflictResolution/ChallengePreference'
import Loader from '@/components/global/Loader'
import NoICanChooseByAddingInformation from '@/components/conflictResolution/NoICanChooseByAddingInformation'
import NoIPreferMakingGroups from '@/components/conflictResolution/NoIPreferMakingGroups'
import SuggestPossibleScenariosUnion from '@/components/conflictResolution/SuggestPossibleScenariosUnion'
import EditorStepper from '@/components/editor/EditorStepper'

import conflictService from '@/services/conflicts.js'
import helpService from '@/services/help.js'
import { CONFLICT_RESOLUTION_STEPS,POSSIBLE_ANSWSERS } from '@/services/conflicts.js'

export default ({
  name: 'ConflictResolution',

  components: {
    ChooseResolutionMode,
    ChooseExclusiveAndUniqueWigoView,
    ChallengePreference,
    EditorStepper,
    Loader,
    NoICanChooseByAddingInformation,
    NoIPreferMakingGroups,
    SuggestPossibleScenariosUnion,
  },

  mixins: [  ],

  data () {
    return {
      loading: true,
      conflict: {},
      todo: {},
      step: undefined
    }
  },

  props: {
  },

  computed: {
    stepIsChooseResolutionMode() {
      return !this.step || conflictService.isChooseResolutionMode(this.step)
    },
    stepIsChooseExclusiveAndUniqueWigo() {
      return conflictService.isChooseExclusiveAndUniqueWigo(this.step)
    },
    stepIsChallengePreference() {
      return conflictService.isChallengePreference(this.step)
    },
    stepIsChooseByAddingInformation() {
      return conflictService.isChooseByAddingInformation(this.step)
    },
    stepIsChooseByAddingInformationWithGroups() {
      return conflictService.isChooseByAddingInformationWithGroups(this.step)
    },
    stepIsConfirmPossibleScenariosUnion() {
      return conflictService.isConfirmPossibleScenariosUnion(this.step)
    },
    stepIsMakeGroups() {
      return conflictService.isMakeGroups(this.step)
    }
  },

  watch: {
    todo() {
      helpService.findHelpPage(this.$store, this.todo)
    }
  },

  methods: {
    answered(answer) {
      switch(answer) {
        case POSSIBLE_ANSWSERS.YES_EXCLUSIVE_AND_UNIQUE:
          this.step = CONFLICT_RESOLUTION_STEPS.CHOOSE_EXCLUSIVE_AND_UNIQUE_WIGO
          helpService.setHelpPage(this.$store, this.step)
          break
        case POSSIBLE_ANSWSERS.NO_BUT_I_CAN_CHOOSE_BY_ADDING_INFORMATION:
          this.step = CONFLICT_RESOLUTION_STEPS.CHOOSE_BY_ADDING_INFORMATION
          helpService.setHelpPage(this.$store, this.step)
          break
        case POSSIBLE_ANSWSERS.NO_I_PREFER_MAKING_GROUPS:
          this.makeGroups()
          break
        case POSSIBLE_ANSWSERS.NO_I_CAN_NOT_DECIDE:
          this.step = CONFLICT_RESOLUTION_STEPS.NO_I_CAN_NOT_DECIDE
          this.iCanNotDecide()
          break
      }
    },
    nextTodo(todo) {
      this.todo = todo
      console.log('nextTodo: todo', this.todo)
      this.step = todo.function
      if(conflictService.isSelectConflict(this.step)) {
        this.$router.push({name: 'conflictsResolution', params: { projectId: this.$route.params.id }})
      }
      else if(conflictService.isConfirmPossibleScenariosUnion(this.step)) {
        this.conflict = todo.conflict
      }
      else if(conflictService.isChooseResolutionMode(this.step)) {
        this.conflict = todo.conflict
      }
    },
    selectConflict(conflict) {
      console.log('selectConflict',conflict)
      this.conflict = conflict
    },
    iCanNotDecide() {
      this.loading = true
      const projectId = this.$route.params.id
      const conflictId = this.$route.params.conflict
      conflictService.prefer(projectId, conflictId, {
        resolution: "Solved",
        todoId: this.todo?.id
      })
      .then(response => {
        const todo = response.data
        this.nextTodo(todo)
      })
      .catch(err => {
        this.$emit('raison-event', { type:'error', messages:[err] })
      })
      .finally(() => {
        this.loading = false
      });
    },
    makeGroups() {
      this.loading = true
      const projectId = this.$route.params.id
      const conflictId = this.$route.params.conflict
      const scenariosIds = this.conflict.combinedScenarios
      conflictService.prefer(projectId, conflictId, {
        resolution: "MakeGroups",
        scenarios: scenariosIds,
        todoId: this.todo?.id
      })
      .then(response => {
        const todo = response.data
        this.nextTodo(todo)
      })
      .catch(err => {
        this.$emit('raison-event', { type:'error', messages:[err] })
      })
      .finally(() => {
        this.loading = false
      });
    }
  },

  created () {
    const projectId = this.$route.params.id
    const conflictId = this.$route.params.conflict
    this.loading = true
    conflictService.getConflict(projectId, conflictId)
      .then(response => {
        this.selectConflict(response.data)
        this.todo = this.conflict.todo
        console.log('ConflictResolution.created: todo', this.todo, response.data)
      })
      .catch(err => {
        this.$emit('raison-event', { type:'error', messages:[err] });
      })
      .finally(() => {
        this.loading = false;
      });
  },
})
</script>
<style>
.container {
  max-width: none;
}
</style>